<template>
  <div v-if="item" class="mt-2 action-item-detail">
    <template>
      <copy-participant-ssn :item="item"></copy-participant-ssn>
      <div class="col-12">
        <label>Plan Type</label>
        <span class="pull-right">{{this.item.account.planType}}</span>
      </div>
      <div class="col-12" v-if="this.item.planStartDate">
        <label>Plan Start Date</label>
        <span class="pull-right">{{$formatters.date(this.item.planStartDate)}}</span>
      </div>
      <div class="col-12">
        <label>Effective Date</label>
        <span class="pull-right">{{$formatters.date(this.item.account.effectiveDate)}}</span>
      </div>
    </template>
<hr>
    <template v-if="isHra">
      <div class="col-12">
        <label>Total Annual Election</label>
        <span v-if="!this.item.account.totalAnnualElection" class="pull-right">{{$formatters.money(this.item.account.annualElection)}}</span>
        <span v-else class="pull-right">{{$formatters.money(this.item.account.totalAnnualElection)}}</span>
      </div>
      <div class="col-12" v-show="this.item.account.employeeOutOfPocket !== null">
        <label>Employee Out of Pocket</label>
        <span class="pull-right">{{$formatters.money(this.item.account.employeeOutOfPocket)}}</span>
      </div>
      <div class="col-12" v-show="this.item.account.coverageTier !== null">
        <label>Coverage Tier</label>
        <span class="pull-right">{{this.item.account.coverageTier}}</span>
      </div>
      <div class="col-12" v-if="this.item.account.isProrated !== null">
        <label>Coverage should be prorated?</label>
        <input type="checkbox" class="pull-right" v-model="this.item.account.isProrated" disabled />
      </div>
      <div class="col-12" v-show="this.item.accountSetupNotes !== null">
        <label>Account Setup Notes</label>
        <br />
        <amf-textarea :columns="3" v-model="this.item.accountSetupNotes" no-tracking></amf-textarea>
      </div>
      <div class="col-12" v-if="this.item.account.firstPayroll">
        <label>Date of First Payroll</label>
        <span class="pull-right">{{$formatters.date(this.item.account.firstPayroll)}}</span>
      </div>
      <div class="col-12" v-if="this.item.location">
        <label>Location</label>
        <span class="pull-right">{{this.location}}</span>
      </div>
    </template>

    <template v-else>
      <div class="col-12">
        <label>Total Annual Election</label>
        <span v-if="!this.item.account.totalAnnualElection" class="pull-right">{{$formatters.money(this.item.account.annualElection)}}</span>
        <span v-else class="pull-right">{{$formatters.money(this.item.account.totalAnnualElection)}}</span>
      </div>
      <div v-if="this.item.account.employeeAnnualElection > 0" class="col-12">
        <label>Employee Annual Election</label>
        <span class="pull-right">{{$formatters.money(this.item.account.employeeAnnualElection)}}</span>
      </div>
      <div v-if="this.item.account.employerAnnualElection > 0" class="col-12">
        <label>Employer Annual Election</label>
        <span class="pull-right">{{$formatters.money(this.item.account.employerAnnualElection)}}</span>
      </div>
      <div class="col-12" v-show="this.item.account.employeeContribution !== null">
        <label>Employee Contribution</label>
        <span class="pull-right">{{$formatters.money(this.item.account.employeeContribution)}}</span>
      </div>
      <div class="col-12" v-show="this.item.account.employerContribution !== null">
        <label>Employer Contribution</label>
        <span class="pull-right">{{$formatters.money(this.item.account.employerContribution)}}</span>
      </div>
      <div class="col-12" v-if="this.item.account.firstPayroll">
        <label>Date of First Payroll</label>
        <span class="pull-right">{{$formatters.date(this.item.account.firstPayroll)}}</span>
      </div>
      <div class="col-12" v-if="this.item.location">
        <label>Location</label>
        <span class="pull-right">{{this.location}}</span>
      </div>
    </template>
<hr>
    <template v-if="this.item.lifeEvent !== null">
      <div class="col-12">
        <label>Life Event</label>
        <div>{{this.item.lifeEvent.what}} on {{$formatters.date(this.item.lifeEvent.when)}}</div>
      </div>
      <div class="col-12 mt-2">
        <label>Notes</label>
        <amf-textarea :columns="3" v-model="lifeEventNotes" no-tracking></amf-textarea>
      </div>
    </template>
  </div>
</template>

<script>
import CopyParticipantSsn from './CopyParticipantSsn.vue';

export default {
  props: ["item"],
  computed: {
    ...amfx.map("plans", "planFlavors"),
    isHra() {
      return _.find(this.planFlavors || [], { planType: "HRA", planCode: this.item.account.planType });
    },
    lifeEventNotes()
    {
      return this.item.lifeEvent.notes || 'No notes.';
    },
    readOnly() {
      return true;
    },
    location() {
        if (this.item.location == null) return "";
        return this.item.location.length > 30 ? `${this.item.location.substring(0, 27)}...` : this.item.location;
    }
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.action-item-detail {
  label {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/action-items/types/AccountUpdateApproval.vue